import React from 'react'
import { IoChevronDown } from 'react-icons/io5'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/UI/BaseDropdown/dropdown-base'
import { FilterCriteria } from '../FilterStore'

interface FilterCriteriaSelectorProps {
  value: FilterCriteria
  onChange: (value: FilterCriteria) => void
}

const CRITERIA_OPTIONS: { value: FilterCriteria; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'one', label: 'One' },
  { value: 'neither', label: 'None' },
]

export function FilterCriteriaSelector({
  value,
  onChange,
}: FilterCriteriaSelectorProps) {
  const selectedLabel =
    CRITERIA_OPTIONS.find((opt) => opt.value === value)?.label || 'All'

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-baseline !border-0 !border-b !border-[#06512F] bg-transparent cursor-pointer mx-2 px-0 gap-1 relative top-[1px]"
        >
          <span className="text-[14px] font-medium text-[#06512F]">
            {selectedLabel}
          </span>
          <IoChevronDown className="w-4 h-4 text-[#06512F] relative top-[3px]" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="min-w-[92px] p-2 bg-white border border-[#C5DED3] shadow-[0px_4px_8px_3px_rgba(6,81,47,0.1)] rounded-[6px]"
      >
        {CRITERIA_OPTIONS.filter((option) => option.value !== value).map(
          (option) => (
            <DropdownMenuItem
              key={option.value}
              onClick={() => onChange(option.value)}
              className="px-2 py-1 text-[14px] text-[#191D23] cursor-pointer hover:bg-[#D1DCD7] rounded-sm"
            >
              {option.label}
            </DropdownMenuItem>
          )
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
